import type { SignatureType } from '@dealstack/prisma-client';

export const isReviewSignatureType = (type: SignatureType) => {
	return type === 'REVIEW';
};

export const isWetInkSignatureType = (type: SignatureType) => {
	return type === 'WET_INK';
};

export const isElectronicSignatureType = (type: SignatureType) => {
	return type === 'ELECTRONIC';
};

/**
 * Manual signature placement needs electronic slots to place — wet ink and review-only have
 * none — and a per-participant document to place them on: a multi-sign document shares one
 * instance across signers, so a single set of coordinates cannot serve them all.
 */
export const allowsManualSignaturePlacement = ({
	signatureType,
	isMultiSign,
}: {
	signatureType: SignatureType;
	isMultiSign: boolean;
}) => isElectronicSignatureType(signatureType) && !isMultiSign;

/**
 * Personalisation resolves each bound field against one investor, and a multi-sign document is a
 * single instance shared by all of them — generation writes those bytes once per investor, so the
 * merged values would be whichever investor rendered last and every other signer would be handed
 * somebody else's details. The same reason the shared instance takes no signature coordinates.
 */
export const allowsFieldPersonalisation = ({ isMultiSign }: { isMultiSign: boolean }) =>
	!isMultiSign;
